
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter, State } from "vuex-class";
import toast from "@/functions/toast.function";
import { AxiosResponse } from "axios";
import { Prop, Watch } from "vue-property-decorator";
import { CANDIDATE_LOGIN } from "@/constants/portal.constant";
import HeaderRegister1 from "@/components/register/HeaderRegister1.vue";
import HeaderRegister2 from "@/components/register/HeaderRegister2.vue";
import HeaderRegister3 from "@/components/register/HeaderRegister3.vue";
@Component({
  components: {
    HeaderRegister3,
    HeaderRegister2,
    HeaderRegister1,
  },
})
export default class HeaderRegister extends Vue {
  @Action("getDegree", { namespace: "admin" })
  getDegree: any;
  @Action("getMajor", { namespace: "admin" })
  getMajor: any;
  @Action("getCountry", { namespace: "admin" })
  getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  getProvince: any;
  @Action("getCity", { namespace: "admin" })
  getCity: any;
  @Action("candidateRegisterSendOtp", { namespace: "school" })
  candidateRegisterSendOtp: any;
  @Action("candidateRegisterValidateOtp", { namespace: "school" })
  candidateRegisterValidateOtp: any;
  @Action("candidateRegisterRegister", { namespace: "school" })
  candidateRegisterRegister: any;
  @Action("getCandidateDetail", { namespace: "school" })
  getCandidateDetail: any;

  @State("school", { namespace: "school" })
  school!: any;
  @State("template", { namespace: "school" })
  template!: any;

  @Prop({ default: 1 })
  templateNumber!: number;
  @Prop({ default: false })
  tokenValid!: boolean;
  @Prop({ default: false })
  eventActive!: boolean;
  @Prop({ default: "" })
  eventEndDate!: string;
  @Prop({ default: false })
  loading!: boolean;

  @Getter("twoColor")
  twoColor!: { text: string; bg: string; border: string };

  user: any = {
    name: "",
    birthday: "",
    gender: "",
    student_number: "",
    degree: "",
    major: "",
    start_year: "",
    end_year: "",
    is_current: "",
    province: null,
    city: null,
    email: "",
    password: "",
    confirm_password: "",
  };
  degrees: Array<any> = [];
  majors: Array<any> = [];
  countries: Array<any> = [];
  provinces: Array<any> = [];
  cities: Array<any> = [];
  step = 1;
  timeUntilReSendOtp = 0;
  otpTimer = "";
  isReSendOtp = false;
  otp = "";
  token = "";
  genders: Array<any> = [
    {
      id: 1,
      name: "Laki-Laki",
    },
    {
      id: 2,
      name: "Perempuan",
    },
  ];
  icons: Array<any> = ["career", "information", "academic", "learning", "cv"];

  @Watch("school", { immediate: true })
  onTrigger(school: School) {
    this.getDegreeData(school);
    this.getCountryData(school);
  }
  @Watch("countries", { immediate: true })
  onCountry() {
    this.getProvinceData();
  }
  get twoBgColor() {
    return this.twoColor.bg;
  }
  get twoTextColor() {
    return this.twoColor.text;
  }
  get isHighSchool() {
    return (
      this.school?.school_type?.name.includes("Vocational High School") ||
      this.school?.school_type?.name.includes("Senior High School") ||
      this.school?.school_type?.name.includes("Madrasah Aliyah")
    );
  }
  get canReSendOtp() {
    return this.timeUntilReSendOtp === 0;
  }
  get candidateId() {
    try {
      return parseInt(atob(this.$route.params.code));
    } catch (e) {
      return null;
    }
  }
  get isTracer() {
    return this.$route.query.tracer === "true";
  }

  created() {
    if (this.candidateId)
      this.getCandidateDetail({
        params: {
          id: this.candidateId,
        },
        success: (response: AxiosResponse) => {
          this.user.name = response.data.data.name;
          this.user.email = response.data.data.email;
        },
      });
  }

  getDegreeData(school?: School) {
    this.getDegree({
      params: {
        school: school?.id,
      },
      success: (response: AxiosResponse) => {
        this.degrees = response.data.data;
      },
    });
  }

  getCountryData(school?: School) {
    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
      },
    });
  }

  getProvinceData() {
    this.getProvince({
      params: {
        country: this.countries?.find(country => country.name === "Indonesia")?.id,
      },
      success: (response: AxiosResponse) => {
        this.provinces = response.data.data;
      },
    });
  }

  onDegreeChange(data: any) {
    if (data) {
      this.getMajor({
        params: {
          degree: data.id,
        },
        success: (response: AxiosResponse) => {
          this.majors = response.data.data;
        },
      });
    } else {
      this.majors = [];
      this.user.major = null;
    }
  }

  onProvinceChange(data: any) {
    if (data) {
      this.getCity({
        params: {
          province: data.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
        },
      });
    } else {
      this.cities = [];
      this.user.city = null;
    }
  }

  onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  isEmail(value: string) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      value
    );
  }

  leadingZeros(num: number, totalLength: number = 2) {
    return String(num).padStart(totalLength, "0");
  }

  otpCountdown() {
    if (!this.canReSendOtp) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      let m = this.leadingZeros(Math.floor(this.timeUntilReSendOtp / 60));
      let s = this.leadingZeros(this.timeUntilReSendOtp % 60);
      this.otpTimer = m + ":" + s;
      this.timeUntilReSendOtp -= 1;
      setTimeout(function () {
        self.otpCountdown();
      }, 1000);
      return;
    }
  }

  sendOtp() {
    if (this.canReSendOtp) {
      if (!this.user.email) {
        toast.warning("The email field is required.");
        return false;
      }
      if (!this.isEmail(this.user.email)) {
        toast.warning("The email field is invalid.");
        return false;
      }
      this.candidateRegisterSendOtp({
        params: {
          email: this.user.email.toLowerCase(),
        },
        success: () => {
          this.isReSendOtp = true;
          this.timeUntilReSendOtp = 90;
          this.otpCountdown();
        },
      });
    }
  }

  next(index: number) {
    if (index < this.step) {
      this.step = index;
      return;
    }

    if (this.step === 1) {
      if (!this.user.name) {
        toast.warning("The name field is required.");
        return false;
      }
      if (!this.user.birthday) {
        toast.warning("The birthday field is required.");
        return false;
      }
      if (!this.user.gender) {
        toast.warning("The gender field is required.");
        return false;
      }
      if (!this.user.student_number) {
        toast.warning("The nis field is required.");
        return false;
      }
      if (!this.user.major) {
        toast.warning("The major field is required.");
        return false;
      }
      if (!this.user.start_year) {
        toast.warning("The start year field is required.");
        return false;
      }
      if (!this.user.is_current) {
        if (!this.user.end_year) {
          toast.warning("The end year field is required.");
          return false;
        }
      }
      if (!this.user.province) {
        toast.warning("The province field is required.");
        return false;
      }
      if (!this.user.city) {
        toast.warning("The city field is required.");
        return false;
      }
      this.step = index;
      if (this.candidateId) this.step = index + 1;
    } else if (this.step === 2) {
      if (!this.user.email) {
        toast.warning("The email field is required.");
        return false;
      }
      if (!this.isEmail(this.user.email)) {
        toast.warning("The email field is invalid.");
        return false;
      }
      if (!this.otp) {
        toast.warning("The otp field is required.");
        return false;
      }
      this.candidateRegisterValidateOtp({
        params: {
          email: this.user.email,
          otp: this.otp,
        },
        success: () => {
          this.step = index + 1;
        },
      });
    } else if (this.step === 3) {
      if (!this.user.password) {
        toast.warning("The password field is required.");
        return false;
      }
      if (!this.user.confirm_password) {
        toast.warning("The confirm password field is required.");
        return false;
      }
      if (this.user.password !== this.user.confirm_password) {
        toast.warning("The confirm password field doesn't match.");
        return false;
      }

      this.candidateRegisterRegister({
        params: {
          id: this.candidateId,
          school_id: this.school.id,
          name: this.user.name,
          birthday: this.user.birthday,
          gender: this.user.gender?.id,
          student_number: this.user.student_number,
          major_id: this.user.major?.id,
          start_year: this.user.start_year,
          end_year: this.user.end_year,
          gpa: this.user.gpa,
          email: this.user.email.toLowerCase(),
          password: this.user.password,
          confirm_password: this.user.confirm_password,
          city_id: this.user.city?.id,
          is_verified: !!this.$route.query.code && this.tokenValid,
        },
        success: (res: AxiosResponse) => {
          this.token = res.data.data.token;
          this.step = index + 1;
          toast.success("Successfully registered.");
        },
      });
    } else if (this.step === 4) {
      if (this.isTracer)
        window.open(
          `${CANDIDATE_LOGIN}?token=${this.token}&redirect=tracer-study`,
          "_blank"
        );
      else
        this.$router.push({
          name: "landing",
        });
    }
  }
}
